import { getPath } from '@/router/common'

const baseUrl = {
  title: '人事行政',
  path: 'personnelAdministration'
}

export default [
  {
    path: getPath('department', baseUrl),
    name: 'department',
    component: () => import(/* webpackChunkName: "department" */ '@/views/personnelAdministration/department/index.vue'),
    meta: {
      title: '部门管理'
    }
  },
  {
    path: getPath('staffingTpl', baseUrl),
    name: 'staffingTpl',
    component: () => import(/* webpackChunkName: "staffingTpl" */ '@/views/personnelAdministration/staffingTpl/index.vue'),
    meta: {
      title: '人事管理-员工档案管理'
    }
  },
  {
    path: getPath('StaffRecords', baseUrl),
    name: 'StaffRecords',
    component: () => import(/* webpackChunkName: "staffRecords" */ '@/views/personnelAdministration/staffingTpl/staffRecords/index.vue'),
    meta: {
      title: '员工新增'
    }
  },
  {
    path: getPath('WorkERegistration', baseUrl),
    name: 'WorkERegistration',
    component: () => import(/* webpackChunkName: "WorkERegistration" */ '@/views/personnelAdministration/staffingTpl/workERegistration/index.vue'),
    meta: {
      title: '员工经历'
    }
  },
  {
    path: getPath('staffLRegistration', baseUrl),
    name: 'staffLRegistration',
    component: () => import(/* webpackChunkName: "staffLRegistration" */ '@/views/personnelAdministration/staffingTpl/staffLRegistration/index.vue'),
    meta: {
      title: '员工请假'
    }
  },
  {
    path: getPath('staffTRegistration', baseUrl),
    name: 'staffTRegistration',
    component: () => import(/* webpackChunkName: "staffTRegistration" */ '@/views/personnelAdministration/staffingTpl/staffTRegistration/index.vue'),
    meta: {
      title: '员工培训'
    }
  },
  {
    path: getPath('staffBRegistration', baseUrl),
    name: 'staffBRegistration',
    component: () => import(/* webpackChunkName: "staffBRegistration" */ '@/views/personnelAdministration/staffingTpl/staffBRegistration/index.vue'),
    meta: {
      title: '员工工伤'
    }
  },
  {
    path: getPath('EmployeeMobilization', baseUrl),
    name: 'EmployeeMobilization',
    component: () => import(/* webpackChunkName: "EmployeeMobilization" */ '@/views/personnelAdministration/staffingTpl/employeeMobilization/index.vue'),
    meta: {
      title: '员工调动'
    }
  },
  {
    path: getPath('staffBPRegister', baseUrl),
    name: 'staffBPRegister',
    component: () => import(/* webpackChunkName: "staffBPRegister" */ '@/views/personnelAdministration/staffingTpl/staffBPRegister/index.vue'),
    meta: {
      title: '员工奖惩'
    }
  },
  {
    path: getPath('StaffEvaluationR', baseUrl),
    name: 'StaffEvaluationR',
    component: () => import(/* webpackChunkName: "StaffEvaluationR" */ '@/views/personnelAdministration/staffingTpl/staffEvaluationR/index.vue'),
    meta: {
      title: '员工考评'
    }
  },
  {
    path: getPath('StaffjzAdd', baseUrl),
    name: 'StaffjzAdd',
    component: () => import(/* webpackChunkName: "StaffjzAdd" */ '@/views/personnelAdministration/staffingTpl/staffjzAdd/index.vue'),
    meta: {
      title: '员工借支'
    }
  },
  {
    path: getPath('StafflzAdd', baseUrl),
    name: 'StafflzAdd',
    component: () => import(/* webpackChunkName: "StafflzAdd" */ '@/views/personnelAdministration/staffingTpl/stafflzAdd/index.vue'),
    meta: {
      title: '员工离职'
    }
  },
  {
    path: getPath('EmployeeSummary', baseUrl),
    name: 'EmployeeSummary',
    component: () => import(/* webpackChunkName: "EmployeeSummary" */ '@/views/personnelAdministration/staffingTpl/employeeSummary/index.vue'),
    meta: {
      title: '员工情况汇总'
    }
  },
  {
    path: getPath('job', baseUrl),
    name: 'job',
    component: () => import(/* webpackChunkName: "job" */ '@/views/personnelAdministration/job/index.vue'),
    meta: {
      title: '职位管理'
    }
  },
  {
    path: getPath('education', baseUrl),
    name: 'education',
    component: () => import(/* webpackChunkName: "education" */ '@/views/personnelAdministration/education/index.vue'),
    meta: {
      title: '学历管理'
    }
  },
  {
    path: getPath('SectorInformation', baseUrl),
    name: 'SectorInformation',
    component: () => import(/* webpackChunkName: "SectorInformation" */ '@/views/personnelAdministration/sectorInformation/index.vue'),
    meta: {
      title: '部门资料'
    }
  },
  {
    path: getPath('addOrEditSJDA', baseUrl),
    name: 'AddOrEditSJDA',
    component: () => import(/* webpackChunkName: "AddOrEditSJDA" */ '@/views/personnelAdministration/addOrEditSJDA/index.vue'),
    meta: {
      title: '司机档案管理新增'
    }
  }
]
